import { debounce as q } from "@yeger/debounce";
function G({
  columns: u,
  columnWidth: l,
  emit: d,
  gap: w,
  items: g,
  maxColumns: f,
  minColumns: i,
  nextTick: k,
  onBeforeUnmount: Y,
  onMounted: D,
  rtl: y,
  scrollContainer: h,
  ssrColumns: s,
  vue: E,
  wall: v,
  watch: p
}) {
  function b(t, e, n, r) {
    const o = R(n);
    return r + e + o <= t ? b(
      t,
      e,
      n + 1,
      r + e + o
    ) : n;
  }
  function R(t) {
    const e = Array.isArray(l.value) ? l.value : [l.value];
    return e[t % e.length];
  }
  function S() {
    const t = b(
      v.value.getBoundingClientRect().width,
      w.value,
      0,
      // Needs to be offset my negative gap to prevent gap counts being off by one
      -w.value
    ), e = j(_(t));
    return e > 0 ? e : 1;
  }
  function _(t) {
    const e = f == null ? void 0 : f.value;
    return e && t > e ? e : t;
  }
  function j(t) {
    const e = i == null ? void 0 : i.value;
    return e && t < e ? e : t;
  }
  if (s.value > 0) {
    const t = M(s.value);
    g.value.forEach(
      (e, n) => t[n % s.value].push(n)
    ), u.value = t;
  }
  let T = 0;
  async function B(t, e) {
    if (t >= g.value.length || (await k(), T !== e))
      return;
    const n = [...v.value.children];
    y.value && n.reverse();
    const r = n.reduce(
      (o, A) => A.getBoundingClientRect().height < o.getBoundingClientRect().height ? A : o
    );
    u.value[+r.dataset.index].push(t), await B(t + 1, e);
  }
  async function c(t = !1) {
    const e = S();
    if (u.value.length === e && !t) {
      d(E === 2 ? "redraw-skip" : "redrawSkip");
      return;
    }
    u.value = M(e);
    const n = h == null ? void 0 : h.value, r = n ? n.scrollTop : window.scrollY;
    await B(0, ++T), n ? n.scrollBy({ top: r - n.scrollTop }) : window.scrollTo({ top: r }), d("redraw");
  }
  const a = typeof ResizeObserver > "u" ? void 0 : new ResizeObserver(q(() => c()));
  return D(() => {
    c(), a == null || a.observe(v.value);
  }), Y(() => a == null ? void 0 : a.unobserve(v.value)), p([g, y], () => c(!0)), p([l, w, i, f], () => c()), { getColumnWidthTarget: R };
}
function M(u) {
  return Array.from({ length: u }).map(() => []);
}
export {
  G as useMasonryWall
};
